import { Box } from '@careguide/theme'

const Card = ({ children, ...props }) => {
  return (
    <Box
      p='1rem'
      boxShadow='low'
      css={`
        border-radius: 5px;
      `}
      {...props}
    >
      {children}
    </Box>
  )
}

export default Card
